/* ============================================================
   DOODLE THEME — theme.js
   ============================================================ */

(function () {
  'use strict';

  /* ─── CURSOR ─── */
  const cur  = document.getElementById('cur');
  const ring = document.getElementById('ring');

  if (cur && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', e => {
      mx = e.clientX;
      my = e.clientY;
      cur.style.left = mx + 'px';
      cur.style.top  = my + 'px';
    });

    (function loop() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(loop);
    })();

    document.querySelectorAll('a, button, .p-card, .price-tier, .arch-card').forEach(el => {
      el.addEventListener('mouseenter', () => {
        cur.style.width  = '18px';
        cur.style.height = '18px';
        ring.style.width  = '50px';
        ring.style.height = '50px';
      });
      el.addEventListener('mouseleave', () => {
        cur.style.width  = '10px';
        cur.style.height = '10px';
        ring.style.width  = '32px';
        ring.style.height = '32px';
      });
    });
  }

  /* ─── SCROLL REVEAL ─── */
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('in'), i * 80);
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));
  } else {
    // Fallback: show all immediately
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('in'));
  }

  /* ─── LIVE VIEWER COUNT ─── */
  const viewerEl = document.getElementById('viewer-count');
  if (viewerEl) {
    let viewers = parseInt(viewerEl.textContent, 10) || 47;
    setInterval(() => {
      viewers += (Math.random() > 0.5 ? 1 : -1) * Math.floor(Math.random() * 3);
      viewers = Math.max(30, Math.min(80, viewers));
      viewerEl.textContent = viewers;
    }, 4800);
  }

  /* ─── PRODUCT CARD VIEWER COUNTS ─── */
  document.querySelectorAll('.p-viewers[data-viewer-min]').forEach(el => {
    const min = parseInt(el.dataset.viewerMin, 10) || 5;
    const max = parseInt(el.dataset.viewerMax, 10) || 40;
    const numEl = el.querySelector('.p-viewer-num');
    if (!numEl) return;

    let count = Math.floor(Math.random() * (max - min + 1)) + min;
    numEl.textContent = count;

    setInterval(() => {
      count += (Math.random() > 0.5 ? 1 : -1) * Math.floor(Math.random() * 2);
      count = Math.max(min, Math.min(max, count));
      numEl.textContent = count;
    }, 6000);
  });

  /* ─── LIVE PURCHASE TOASTS ─── */
  const toast     = document.getElementById('toast');
  const toastText = document.getElementById('toast-text');

  if (toast && toastText) {
    const toasts = [
      '<strong>Marcus from Brooklyn</strong> just copped the Archive Tee — 2 min ago',
      '<strong>Someone in LA</strong> just copped the Art Crewneck — 4 min ago',
      '<strong>Jordan from Chicago</strong> joined the Drop 02 waitlist — just now',
      '<strong>Alex from Atlanta</strong> just copped the Canvas Hoodie — 1 min ago',
      '<strong>85 people</strong> copped in the first 3 minutes of Drop 01',
      '<strong>Riley from NYC</strong> just joined 2,848 people on the waitlist',
    ];

    let toastIndex = 0;

    function showToast() {
      toastText.innerHTML = toasts[toastIndex];
      toast.classList.add('show');
      toastIndex = (toastIndex + 1) % toasts.length;
      setTimeout(() => toast.classList.remove('show'), 3800);
    }

    setTimeout(() => {
      showToast();
      setInterval(showToast, 7500);
    }, 4000);
  }

  /* ─── COUNTDOWN TIMER ─── */
  const countdownEl = document.querySelector('.drop-countdown[data-drop-date], .drop-hero[data-drop-date]');
  if (countdownEl) {
    const dropDate = new Date(countdownEl.dataset.dropDate);
    const cdD = document.getElementById('cd-d');
    const cdH = document.getElementById('cd-h');
    const cdM = document.getElementById('cd-m');
    const cdS = document.getElementById('cd-s');

    function pad(n) { return String(n).padStart(2, '0'); }

    function updateCountdown() {
      const diff = dropDate - Date.now();
      if (diff <= 0) {
        if (cdD) cdD.textContent = '00';
        if (cdH) cdH.textContent = '00';
        if (cdM) cdM.textContent = '00';
        if (cdS) cdS.textContent = '00';
        return;
      }
      const d = Math.floor(diff / 864e5);
      const h = Math.floor((diff % 864e5) / 36e5);
      const m = Math.floor((diff % 36e5) / 6e4);
      const s = Math.floor((diff % 6e4) / 1e3);
      if (cdD) cdD.textContent = pad(d);
      if (cdH) cdH.textContent = pad(h);
      if (cdM) cdM.textContent = pad(m);
      if (cdS) cdS.textContent = pad(s);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ─── CART: Update count in nav ─── */
  function updateCartCount(count) {
    const cartEl = document.querySelector('.nav-cart');
    if (!cartEl) return;
    const countEl = cartEl.querySelector('.nav-cart-count');
    if (count > 0) {
      if (countEl) {
        countEl.textContent = '(' + count + ')';
      } else {
        cartEl.insertAdjacentHTML('beforeend', '<span class="nav-cart-count">(' + count + ')</span>');
      }
    } else if (countEl) {
      countEl.remove();
    }
    cartEl.setAttribute('aria-label', 'Shopping cart, ' + count + ' items');
  }

  /* ─── WAITLIST FORM: AJAX-enhance ─── */
  const waitlistForm = document.getElementById('waitlist-form');
  if (waitlistForm) {
    waitlistForm.addEventListener('submit', function (e) {
      const btn = waitlistForm.querySelector('.email-btn');
      if (btn) {
        btn.textContent = 'Joining...';
        btn.disabled = true;
      }
      // Let Shopify handle the actual form submission (no e.preventDefault())
      // The page will reload to the success state via Liquid form.posted_successfully?
    });
  }

})();

/* ─── ADD TO CART (AJAX) ─── */
(function () {
  // Cart toast notification element
  var cartToast = document.createElement('div');
  cartToast.className = 'cart-toast';
  cartToast.setAttribute('role', 'status');
  cartToast.setAttribute('aria-live', 'polite');
  document.body.appendChild(cartToast);

  function showCartToast(message) {
    cartToast.textContent = message;
    cartToast.classList.add('show');
    setTimeout(function () { cartToast.classList.remove('show'); }, 2800);
  }

  function updateCartCount(count) {
    var cartEl = document.querySelector('.nav-cart');
    if (!cartEl) return;
    var countEl = cartEl.querySelector('.nav-cart-count');
    if (count > 0) {
      if (countEl) {
        countEl.textContent = '(' + count + ')';
      } else {
        cartEl.insertAdjacentHTML('beforeend', '<span class="nav-cart-count">(' + count + ')</span>');
      }
    } else if (countEl) {
      countEl.remove();
    }
    cartEl.setAttribute('aria-label', 'Shopping cart, ' + count + ' items');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-add-to-cart');
    if (!btn) return;

    var variantId = btn.dataset.variantId;
    var productTitle = btn.dataset.productTitle || 'Item';
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    var routes = (window.Doodle && window.Doodle.routes) || {};
    var addUrl = routes.cartAddUrl || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.status) {
        showCartToast('Could not add to cart: ' + (data.description || data.message));
        btn.disabled = false;
        btn.textContent = 'Add to Bag';
      } else {
        // Fetch updated cart count
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            showCartToast('✓ ' + productTitle + ' added to bag');
            btn.textContent = 'Added ✓';
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = 'Add to Bag';
            }, 2000);
          });
      }
    })
    .catch(function () {
      showCartToast('Something went wrong. Please try again.');
      btn.disabled = false;
      btn.textContent = 'Add to Bag';
    });
  });
})();
